import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  Grid,
} from '@mui/material';
import React, {ReactNode} from 'react';
import {Link} from 'react-router-dom';
import theme, {themeColors} from '../../theme/Theme';

const classes = {
  alignCenter: {
    textAlign: 'center',
  },
  alignLeft: {
    textAlign: 'left',
  },
  alignRight: {
    textAlign: 'right',
  },
  button: {
    backgroundColor: themeColors.backgroundHighlight,
    border: `2px solid #25425E`,
    color: themeColors.white,
    padding: '5px 60px',
    margin: 0,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: themeColors.backgroundDark,
      border: `2px solid ${themeColors.backgroundDark}`,
    },
  },
  footer: {
    borderTop: '1px solid #25425E',
    padding: `${theme.spacing(3)} ${theme.spacing(5)}`,
  },
  heading: {
    borderBottom: '1px solid #25425E',
    padding: `${theme.spacing(3)} ${theme.spacing(5)}`,
    '& .MuiCardHeader-subheader': {
      color: themeColors.tan,
      fontSize: 18,
    },
    '& .MuiCardHeader-title': {
      color: themeColors.white,
      fontSize: 30,
      fontWeight: 600,
    },
  },
  panel: {
    boxShadow: 'none',
    padding: `${theme.spacing(3)} ${theme.spacing(5)}`,
  },
  root: {
    background: themeColors.backgroundHighlight,
    boxShadow: 'none',
    color: themeColors.white,
  },
};

interface MfaEnrolmentPanelProps {
  align?: 'center' | 'left' | 'right';
  backTo?: string;
  button?: ReactNode;
  children?: ReactNode;
  subTitle: string;
  title: string;
}

function MfaEnrolmentPanel({
  align = 'center',
  backTo,
  button,
  children,
  subTitle,
  title,
}: MfaEnrolmentPanelProps) {
  const alignmentClass = () => {
    switch (align) {
      case 'left':
        return classes.alignLeft;
      case 'right':
        return classes.alignRight;
      default:
        return classes.alignCenter;
    }
  };

  return (
    <Box>
      <Container maxWidth="sm">
        <Card sx={classes.root}>
          <CardHeader sx={classes.heading} title={title} subheader={subTitle} />

          <CardContent className={`${alignmentClass()} ${classes.panel}`}>
            {children}
          </CardContent>

          <CardActions sx={classes.footer}>
            <Grid container justifyContent="space-between">
              <Grid item>
                {backTo && (
                  <Button
                    sx={classes.button}
                    component={Link}
                    variant="outlined"
                    to={backTo}
                  >
                    Back
                  </Button>
                )}
              </Grid>
              <Grid item>{button}</Grid>
            </Grid>
          </CardActions>
        </Card>
      </Container>
    </Box>
  );
}

export default MfaEnrolmentPanel;
